angular.module("avlib").directive("dateFilter", function(){
	return {
		template: require("!html-loader!./DateFilterTemplate.html"),
		restrict: "E",
		scope: {
            filter: '=',
            onChange: '&',
		},
		
		controller: ["$scope", function($scope){
            
			$scope.dateFilterChanged = function(){
                if ($scope.filter.filterChanged){
                	$scope.filter.filterChanged();
                }
                $scope.onChange();
			};
			
		    /**
		     * Listener para click no botão de limpeza do campo de filtragem por data de início do intervalo de interesse.
		     */
		    $scope.clearFromDateButtonClicked = function(){
		    	$scope.filter.fromDate = null;
                if ($scope.filter.filterChanged){
                	$scope.filter.filterChanged();
                }
                $scope.onChange();
		    };
		    
		    /**
		     * Listener para click no botão de limpeza do campo de filtragem por data de fim do intervalo de interesse.
		     */
		    $scope.clearByDateButtonClicked = function(){
		    	$scope.filter.byDate = null;
                if ($scope.filter.filterChanged){
                	$scope.filter.filterChanged();
                }
                $scope.onChange();
		    };			
		}],
	};
});
